
<!--
 * @Description: 教职工详情 党团信息
 * @Author: 张天伟
 * @Date: 2023-03-08 11:59:14
 * @LastEditors: PF
 * @LastEditTime: 2024-10-15 16:37:59
-->
<template>
  <div>
    <el-descriptions v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="政治面貌" label-align="right" align="left" width="120px" span="2">{{item.zzmmbt}}</el-descriptions-item>
      <el-descriptions-item label="参加日期" label-align="right" align="left" width="120px" span="2">{{item.cjrq}}</el-descriptions-item>
      <el-descriptions-item label="参加所在单位" label-align="right" align="left" width="120px" span="2">{{item.cjszdw}}</el-descriptions-item>
      <el-descriptions-item label="介绍人" label-align="right" align="left" width="120px" span="2">{{item.jsr}}</el-descriptions-item>
      <el-descriptions-item label="转正日期" label-align="right" align="left" width="120px" span="2">{{item.zzrq}}</el-descriptions-item>
      <el-descriptions-item label="异常类别" label-align="right" align="left" width="120px" span="2">{{item.yclbbt}}</el-descriptions-item>
      <el-descriptions-item label="异常原因" label-align="right" align="left" width="120px" span="2">{{item.ycyy}}</el-descriptions-item>
      <el-descriptions-item label="异常日期" label-align="right" align="left" width="120px" span="2">{{item.ycrq}}</el-descriptions-item>
      <el-descriptions-item label="转入日期" label-align="right" align="left" width="120px" span="2">{{item.zrrq}}</el-descriptions-item>
      <el-descriptions-item label="转入前单位" label-align="right" align="left" width="120px" span="2">{{item.zrqdw}}</el-descriptions-item>
      <el-descriptions-item label="转出日期" label-align="right" align="left" width="120px" span="2">{{item.zcrq}}</el-descriptions-item>
      <el-descriptions-item label="转出单位" label-align="right" align="left" width="120px" span="2">{{item.zcdw}}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({ row: { type: Object, required: false } })
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = {
        url: '/api/v2/renliziyuan/jiaozhigongdangtuanxinxi/list',
        data: { id: props.row.id, order: 'gh', sort: 'asc' }
      }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
